import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidatePreviewFeeResponse from "./customerRefundCandidatePreviewFeeResponse";
import CustomerRefundCandidatePreviewRefundPaymentResponse from "./customerRefundCandidatePreviewRefundPaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePreviewDetailResponse {
  /**
   * Charge price.
   */
  @observable
  chargePrice!: number;

  /**
   * Raw refund amount.
   */
  @observable
  rawRefundAmount!: number;

  /**
   * Refund amount.
   */
  @observable
  refundAmount!: number;

  @observable
  @Type(() => CustomerRefundCandidatePreviewRefundPaymentResponse)
  refundPayment!: CustomerRefundCandidatePreviewRefundPaymentResponse;

  /**
   * Refund fees.
   */
  @observable
  @Type(() => CustomerRefundCandidatePreviewFeeResponse)
  fees!: CustomerRefundCandidatePreviewFeeResponse[];
}
